export const createValueNode = () => {

    let valueGetter = null;
    return {
        setValueGetter: (getter) => {
            valueGetter = getter;
        },
        getValue: () => {
            if (valueGetter == null) {
                throw "[VALUE NODE] Is next called?";
            }
            return valueGetter();
        },
    };
};
